/**
 * Configuração do WebSocket para notificações em tempo real
 * 
 * O serviço de webhook (webhook.ortho.local) envia notificações quando:
 * - Um agendamento é criado/alterado/cancelado
 * - Um paciente chega (check-in)
 * - Os horários do dentista são alterados
 */
export const WEBSOCKET_CONFIG = {
  // Host do servidor Reverb (WebSocket)
  host: process.env.REACT_APP_WEBSOCKET_HOST || 'localhost',
  
  // Porta do WebSocket
  port: parseInt(process.env.REACT_APP_WEBSOCKET_PORT || '8080', 10),
  
  // Chave da aplicação Reverb
  key: process.env.REACT_APP_WEBSOCKET_KEY || 'webhook-ortho-key',
  
  // Habilitar WebSocket (pode ser desabilitado em dev)
  enabled: process.env.REACT_APP_WEBSOCKET_ENABLED === 'true',
};
